import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import type { EntnahmeReasonInput } from '@/api/types'
import { entnahmeReasonsApi } from '@/api/endpoints/entnahme-reasons'

export function useEntnahmeReasons(restaurantId: number) {
  return useQuery({
    queryKey: ['entnahmeReasons', restaurantId],
    queryFn: () => entnahmeReasonsApi.get(restaurantId),
    enabled: Number.isFinite(restaurantId) && restaurantId > 0,
    staleTime: 0,
  })
}

export function useSaveEntnahmeReasons(restaurantId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (items: Array<EntnahmeReasonInput>) =>
      entnahmeReasonsApi.save(restaurantId, items),
    onSuccess: () => {
      toast.success('Entnahme reasons saved')
      qc.invalidateQueries({ queryKey: ['entnahmeReasons', restaurantId] })
    },
    onError: () => {
      toast.error('Failed to save entnahme reasons')
    },
  })
}
